export default __webpack_public_path__ + "static/media/keller-laptop.52883e8b.png";